import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1256f2e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "content" }
const _hoisted_2 = { id: "app-preview-section" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StoreLinks = _resolveComponent("StoreLinks")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("img", {
        id: "mac-home-screen",
        src: _ctx.macHomeScreenSource,
        alt: "mac home screen"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        id: "iphone-home-screen",
        src: _ctx.iPhoneHomeScreenSource,
        alt: "iphone home screen"
      }, null, 8, _hoisted_4)
    ]),
    _createVNode(_component_StoreLinks, { isDarkMode: _ctx.isDarkMode }, null, 8, ["isDarkMode"])
  ]))
}